'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = 'M533.3-31.5c2.1-.8 4.4-.6 6.4 .4 2.7 1.4 4.4 4.1 4.4 7.1l0 145.2c0 46-25.9 86-64 106.1L480 472c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-128.2-119.7 88.2 21 0c28 0 50.6 22.7 50.7 50.7 0 16.2-13.1 29.3-29.3 29.3L136 512c-39.8 0-72-32.2-72-72l0-256c0-30.9-25.1-56-56-56-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8 39.8 0 72 32.2 72 72l0 136.3c35.3-93.2 125-159.7 230.5-160.3-4.2-12.2-6.5-25.2-6.5-38.8l0-145.2 .3-2.2c.6-2.1 2.1-3.9 4.1-4.9 2.7-1.4 5.9-1.1 8.3 .7l85.9 62.5 42.7 0 85.9-62.5 2-1zM312 176C183.9 176 80 279.9 80 408l0 32c0 30.9 25.1 56 56 56l186.7 0c7.4 0 13.3-6 13.3-13.3 0-19.1-15.5-34.7-34.7-34.7L256 448c-4.4 0-8-3.6-8-8l0-40c0-26.5-21.5-48-48-48l-8 0c-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8l8 0c35.3 0 64 28.7 64 64l0 24.2 139.3-102.6 2-1.1c2.1-.8 4.4-.6 6.4 .4 2.7 1.4 4.4 4.1 4.4 7.1l0 144c0 13.2 10.8 24 24 24s24-10.8 24-24l0-237.7c-12.5 4.4-26 6.9-40 6.9-46.5 0-86.8-26.5-106.7-65.2l-5.3 0zM452.7 46.5c-1.4 1-3 1.5-4.7 1.5l-48 0c-1.7 0-3.4-.5-4.7-1.5L320-8.3 320 121.2c0 57.4 46.6 104 104 104s104-46.6 104-104l0-129.4-75.3 54.8zM384 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;